import React, { useEffect, useState } from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { messageFactory, Topic } from '@annunciate/core';
import { useOnPurchaseHandler } from '../hooks';
import { getProduct } from '../utils';
export const PurchaseLink = ({ id: productId }) => {
    const [product, setProduct,] = useState(undefined);
    const handler = useOnPurchaseHandler();
    useEffect(() => {
        async function run() {
            const product = await getProduct(productId);
            setProduct(product);
        }
        run();
    }, [productId]);
    useEffect(() => {
        if (product) {
            messageFactory(Topic.PURCHASE_STARTED, { product_id: productId }).finally(() => {
                handler(product, '/');
            });
        }
    }, [!!product]);
    if (!productId) {
        return null;
    }
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, null, product === null ?
            `Unable to locate product with id: '${productId}'` :
            `Please wait while we prepare your purchase.`),
        product !== null && (React.createElement(LinearProgress, { style: { marginVertical: 10 } }))));
};
//# sourceMappingURL=PurchaseLink.js.map